import { render, staticRenderFns } from "./FWindow.vue?vue&type=template&id=5b61d806&"
import script from "./FWindow.vue?vue&type=script&lang=js&"
export * from "./FWindow.vue?vue&type=script&lang=js&"
import style0 from "./FWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports